import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Account} from 'app/core/auth/account.model';
import {AppuntamentoPage} from '../../models/appuntamento';
import {Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {AmministrazioneService} from '../../services/amministrazione.service';
import {MessageService} from '../../services/message.service';
import {UserData} from '../../models/user-data';
import {Employee} from '../../models/employee';
import {Observable, take} from 'rxjs';
import {PrenotazioneAppuntamentoService} from '../../services/prenotazione-appuntamento.service';
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {AlertService} from '../../shared/alert/alert.service';
import {format} from "date-fns";
import { CD_SERVIZIO_SALE } from '../../app.constants';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-dettaglio-appuntamento',
  templateUrl: './dettaglio-appuntamento.component.html',
  styleUrls: ['./dettaglio-appuntamento.component.scss'],
})
export class DettaglioAppuntamentoComponent extends SubscriptionManager implements OnInit, OnDestroy {
  @ViewChild('_CARD_OPERATORE') _card_operatore!: ElementRef;
  @ViewChild('_TEXTAREA_NOTE') _textarea_note!: ElementRef;
  testoAlert!: string;
  appMessage!: AppuntamentoPage;
  sessionAppuntamento?: AppuntamentoPage;
  isDisabled = true;
  account: Account | null = null;
  loading = false;
  dichiarante?: UserData;
  richiedente?: Employee;
  operatore: Employee[] = [];
  lineLoading = false;
  statoForm = this.fb.group({
    content: this.fb.group({
      id: this.fb.control<number | null>(null),
      stato: ''
    })
  });

  constructor(
    public route: Router,
    public fb: FormBuilder,
    private apiservice: AmministrazioneService,
    private messageService: MessageService,
    public appServ: PrenotazioneAppuntamentoService,
    private confService: ConfigurazioneGeneraleService,
    private alertService: AlertService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loading = true;
    this.checkNewMessage()
      .pipe(take(1))
      .subscribe({
        next: value => {
          this.appMessage = value;
          if (this.appMessage) {
            if (
              localStorage.getItem('sessionAppuntamento' || '{}') === undefined ||
              localStorage.getItem('sessionAppuntamento' || '{}') === null
            ) {
              this.setLocalStorage();
              this.getLocalStorage();
              this.codeStati();
            } else {
              this.getLocalStorage();
              this.codeStati();
            }
          } else {
            this.route.navigate(['Appuntamenti/lista-prenotazioni']).catch(() => this.route.navigate(['home']));
          }
        },
        complete: () => (this.loading = false),
      });
  }

  ngOnDestroy(): void {
    localStorage.removeItem('sessionAppuntamento');
  }

  codeStati(): void {
    switch (this.sessionAppuntamento?.content?.tiStato) {
      case 'C': {
        if(this.sessionAppuntamento.content.servizioErogato.servizio.codice === CD_SERVIZIO_SALE){
          this.sessionAppuntamento.content.tiStato = 'Confermato';
        }else{
          this.sessionAppuntamento.content.tiStato = 'Completato';
        }
        break;
      }
      case 'A': {
        this.sessionAppuntamento.content.tiStato = 'Annullato';
        break;
      }
      case 'F': {
        if(this.sessionAppuntamento.content.servizioErogato.servizio.codice === CD_SERVIZIO_SALE) {
          this.sessionAppuntamento.content.tiStato = "Da confermare";
        }else {
          this.sessionAppuntamento.content.tiStato = 'Programmato';
        }
        break;
      }
      case 'T': {
        this.sessionAppuntamento.content.tiStato = 'Trasferito';
        break;
      }
    }
  }

  checkNewMessage(): Observable<AppuntamentoPage> {
    return this.messageService.singleAppointmentMessage;
  }

  checkDirettoCruscotto(): boolean{
    return window.history.state.previousRoute === 'Cruscotto/le-mie-attivita';
  }

  goToCruscotto():void{
    return void this.route.navigate(['Cruscotto/le-mie-attivita'], {state: {cambioVisuale: true}}).then();
  }

  goToHome():void{
    window.location.href = this.confService.configurazione.linkHome;
  }

  formPatchValueAnnullato(id?: number | null | undefined): void {
    this.statoForm.patchValue({
      content: {
        id,
        stato: 'A',
      }
    });
  }

  setLocalStorage(): void {
    localStorage.removeItem('sessionAppuntamento');
    localStorage.setItem('sessionAppuntamento', JSON.stringify(this.appMessage));
  }

  getLocalStorage(): any {
    this.sessionAppuntamento = JSON.parse(localStorage.getItem('sessionAppuntamento') || '{}');
    return this.sessionAppuntamento;
  }

  async goToListaAppuntamenti(): Promise<void> {
    await this.route.navigate(['Appuntamenti/lista-prenotazioni'])
  }

  changeStatoAppuntamento(): void {
    this.loading = true;
    this.subs.sink = this.appServ.modificaAppuntamento((this.statoForm.value).content?.id).subscribe({
      next: res => (this.appMessage = res),
      error: (err) => {
        let msg = ''
        if(err.error.messaggio){
          msg = err.error.messaggio;
        }else if(err.error.status === 401){
          msg = "Utente non autenticato o sessione scaduta";
        }else{
          msg = "Errore nel caricamento trasferimento di un appuntamento con stato: " + String(err.error.status);
        }
        this.alertService.creaAlert(msg, "danger", "sticky", 4000, true);
        this.loading = false;
      },
      complete: () => {
        localStorage.removeItem('sessionAppuntamento');
        if (
          localStorage.getItem('sessionAppuntamento' || '{}') === null ||
          localStorage.getItem('sessionAppuntamento' || '{}') === undefined
        ) {
          this.setLocalStorage();
          this.getLocalStorage();
          this.codeStati();
        } else {
          this.getLocalStorage();
          this.codeStati();
        }
        this.alertService.creaAlert('Stato appuntamento cambiato con successo', 'success', 'sticky', 8000, true);
        this.loading = false;
      },
    });
  }

  formatTime(inputTime: string | undefined): string {
    const inputDate = new Date(`1970-01-01T${<string>inputTime}`);
    return format(inputDate, 'HH:mm');
  }
}
